import React from 'react';
import { IconButton } from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import * as Style from '../styles';

function ReportSectionCard({ title, children }) {
    return (
        <Style.SectionCard>
            <Style.SectionHeader>
                <Style.SectionTitle>{title}</Style.SectionTitle>
                <IconButton size="small" aria-label="compartilhar">
                    <ShareOutlinedIcon style={{ color: '#DCC6B7' }} />
                </IconButton>
            </Style.SectionHeader>
            <Style.SectionScroll>{children}</Style.SectionScroll>
        </Style.SectionCard>
    );
}

export default ReportSectionCard;
